import { REMOVER_FILTRO_AGENCIA } from '../types'

export default function removerFiltroAgencia (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_AGENCIA
  }
}
